export { viewTopicResource as default } from './resources';
